import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PaymentTermApplyFor } from 'contexts/Metadata/types';
import { useProducts } from 'contexts/Products';
import { PaymentTermsField } from 'fields';
import { useFormikContext } from 'formik';
import type { IGenericObject } from 'types';

import type { IPaymentTerms } from './types';

export default function PaymentTerms({ disabled }: IPaymentTerms) {
  const { t } = useTranslation('CreateOrder');

  const {
    state,
    selectors: { selectProduct },
  } = useProducts();

  const { values } = useFormikContext<IGenericObject>();

  const product = useMemo(() => {
    if (values.packagedItemReference) {
      return selectProduct(state, values.packagedItemReference);
    }
  }, [selectProduct, state, values.packagedItemReference]);

  const applyFor = useMemo(() => {
    switch (product?.packageIsSolid) {
      case true:
        return PaymentTermApplyFor.solid;
      case false:
        return PaymentTermApplyFor.liquid;
      default:
        return;
    }
  }, [product]);

  return (
    <PaymentTermsField
      required
      disabled={disabled}
      name="paymentTerms.paymentTermsCode"
      label={t('ProductForm.labels.paymentTerms')}
      placeholder={t('ProductForm.placeholders.paymentTerms')}
      applyFor={applyFor}
    />
  );
}
